var map = {
	"./allinc.png": 89894,
	"./allinclusive.png": 27672,
	"./alpereiser.png": 3537,
	"./amisol.png": 14610,
	"./apollo.png": 75012,
	"./lionalpin.png": 91589,
	"./nazar.png": 24817,
	"./neckermann.png": 83827,
	"./norwegianholidays.png": 68168,
	"./sasholidays.png": 81619,
	"./sembo.png": 48499,
	"./solfaktor.png": 5516,
	"./test.png": 27681,
	"./ticket.png": 50033,
	"./tripx.png": 76200,
	"./tui.png": 64261,
	"./ving.png": 36407,
	"./vingdynamic.png": 94562,
	"./vitalreiser.png": 11275
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62596;